import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'app-root',
    template: `
        <ngx-spinner
            bdColor="rgba(255, 255, 255, 0.94)"
            size="medium"
            type="ball-scale-multiple"
            [fullScreen]="true">

            <div class="truck-loader">

                <!-- GPS Pin -->
                <div class="loader-pin">
                    <div class="pin-head">
                        <div class="pin-dot"></div>
                    </div>
                </div>

                <!-- Moving road -->
                <div class="loader-road">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>

                <div class="loader-text">
                    Loading...
                </div>

            </div>

        </ngx-spinner>

        <router-outlet></router-outlet>
    `,
    styles: [`
        .truck-loader {
            width: 130px;
            text-align: center;
            font-family: Arial, sans-serif;
        }

        /* -------------------------
           GPS PIN
        ------------------------- */

        .loader-pin {
            width: 52px;
            height: 52px;
            margin: 0 auto 8px;
            position: relative;
            animation: pinFloat 1.6s ease-in-out infinite;
        }

        .pin-head {
            width: 42px;
            height: 42px;
            margin: auto;
            border: 3px solid #4b7bec;
            border-radius: 50% 50% 50% 8px;
            transform: rotate(-45deg);
            display: flex;
            align-items: center;
            justify-content: center;
            background: #ffffff;
            box-shadow: 0 5px 14px rgba(75, 123, 236, 0.14);
        }

        .pin-dot {
            width: 11px;
            height: 11px;
            border-radius: 50%;
            background: #4b7bec;
            transform: rotate(45deg);
            box-shadow: 0 0 0 4px rgba(75, 123, 236, 0.08);
        }

        /* -------------------------
           ROAD
        ------------------------- */

        .loader-road {
            width: 82px;
            height: 3px;
            margin: 0 auto;
            position: relative;
            overflow: hidden;
            border-radius: 5px;
            background: #e9edf5;
        }

        .loader-road span {
            position: absolute;
            width: 15px;
            height: 3px;
            border-radius: 5px;
            background: #8faef5;
            animation: roadMove 1.2s linear infinite;
        }

        .loader-road span:nth-child(1) {
            left: -20px;
            animation-delay: 0s;
        }

        .loader-road span:nth-child(2) {
            left: -20px;
            animation-delay: 0.4s;
        }

        .loader-road span:nth-child(3) {
            left: -20px;
            animation-delay: 0.8s;
        }

        /* -------------------------
           TEXT
        ------------------------- */

        .loader-text {
            margin-top: 12px;
            font-size: 12px;
            font-weight: 500;
            letter-spacing: 0.4px;
            color: #697386;
        }

        /* -------------------------
           ANIMATIONS
        ------------------------- */

        @keyframes pinFloat {
            0%,
            100% {
                transform: translateY(0);
            }

            50% {
                transform: translateY(-5px);
            }
        }

        @keyframes roadMove {
            0% {
                transform: translateX(0);
                opacity: 0;
            }

            20% {
                opacity: 1;
            }

            100% {
                transform: translateX(105px);
                opacity: 0;
            }
        }
    `]
})
export class AppComponent implements OnInit, OnDestroy {

    subscription: Subscription;


    constructor(private router: Router) {
    }

    ngOnInit() {
        this.subscription = this.router.events
            .pipe(
                filter(event => event instanceof NavigationEnd)
            )
            .subscribe(() => window.scrollTo(0, 0));
    }


    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }



}